import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {MsalService} from '@azure/msal-angular';
import {AccountInfo} from '@azure/msal-common';
import {JwtValidatorService} from '../services/jwt-validator.service';

export const oauthUsuarioActivoGuard: CanActivateFn = (route, state) => {
  const msalService: MsalService = inject(MsalService);
  const jwtValidator: JwtValidatorService = inject(JwtValidatorService);
  const activeAccount: AccountInfo | null = msalService.instance.getActiveAccount();
  const router = inject(Router);

  if (activeAccount === null) {
    const salesForceToken = sessionStorage.getItem('sales_force_token');

    // Validar existencia Y expiración del token
    if (salesForceToken === null || jwtValidator.isTokenExpired(salesForceToken)) {
      // Limpiar token expirado antes de redirigir
      if (salesForceToken !== null) {
        sessionStorage.removeItem('sales_force_token');
        sessionStorage.removeItem('auth_provider');
        sessionStorage.removeItem('permiso');
      }

      router.navigate(['/login']).then(r => {
      });
      return false;
    }
    return true;
  }
  return true;
};
